import { Component, OnInit, Input } from '@angular/core';
import { gotxModalComponent } from 'src/app/gotxModal/gotxModal.component';
import { ServiceStock } from 'src/app/service-stock.service';

@Component({
  selector: 'app-gotx-market-depth',
  templateUrl: './gotx-market-depth.component.html',
  styleUrls: ['./gotx-market-depth.component.scss']
})
export class GotxMarketDepthComponent implements OnInit {

  @Input('exchange') exchange: string;
  @Input('product') product: string;
  @Input('symbol') symbol: string;
  @Input('exchSymbol') exchSymbol: string;
  @Input('board') board: string = 'NR';
  @Input('depthLevel') depthLevel: number = 10;

  selectedStock: any;
  depthList = [];
  rowData: any;

  constructor(private services: ServiceStock) { }
  counter(i: number) {

    if (i <= 0)
      return new Array(0);
    else
      return new Array(i);
  }
  ngOnInit() {
    let stockKey = this.exchange + "#" + this.product + "#" + this.exchSymbol;
    this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
    this.depthList = Array(this.depthLevel).fill(1);
  }

  ngOnChanges() {
    let stockKey = this.exchange + "#" + this.product + "#" + this.exchSymbol;
    let _stock = this.services.dataStore.stockMasterMap.get(stockKey);
    if (_stock) {
      this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
    }
    
    //  this.selectedStock.askList =  [
    //     {
    //             "offerPrice": 212.7,
    //             "offerQty": 1000,
    //             "offerOrder": 1
    //           },
    //           {
    //             "offerPrice": 212.8,
    //             "offerQty": 460,
    //             "offerOrder": 1
    //           },
    //           {
    //             "offerPrice": 213,
    //             "offerQty": 506,
    //             "offerOrder": 4
    //           },
    //           {
    //             "offerPrice": 213.5,
    //             "offerQty": 130,
    //             "offerOrder": 1
    //           }]

    //     ,
    //     this.selectedStock.bidList = [
    //       {
    //         "bidPrice": 210.5,
    //         "bidQty": 120,
    //         "bidOrder": 2
    //       },
    //       {
    //         "bidPrice": 210.3,
    //         "bidQty": 75,
    //         "bidOrder": 2
    //       },
    //       {
    //         "bidPrice": 210.2,
    //         "bidQty": 1460,
    //         "bidOrder": 6
    //       }]
  }

  openModal(buyOrSell: string, order, price, qty, idx) {
    let params = {
      symbol: this.symbol,
      exchange: this.exchange,
      product: this.product,
      exchSymbol: this.exchSymbol,
      board: this.selectedStock.board,
      order: order,
      price: price,
      qty: qty,
      orderEntryType: buyOrSell.toUpperCase()
    }

    let totalQty = 0;

    if (buyOrSell == "Buy") {
      this.selectedStock.askList.slice(0, idx + 1).forEach(el => {
        totalQty += el.offerQty;
      })
    } else {
      this.selectedStock.bidList.slice(0, idx + 1).forEach(el => {
        totalQty += el.bidQty;
      })
    }

    params.qty = totalQty;

    const modalRef = this.services.openModal(gotxModalComponent, 'lg', params, buyOrSell);
  }

  public setSelectedStock(stock: any) {
    this.selectedStock = stock;
  }

  public getSelectedStock(): any {
    return this.selectedStock;
  }
}
